import template from './sw-cms-block-image-gallery.html.twig';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
